Service = App.loadClass 'core::Angular/Service'

class exports.PlacementService extends Service

    constructor: (@http) ->
        undefined

    getSurveyFields: (survey_result) =>
        params =
            survey_result_id: survey_result.id

        return @http.post('backend/grower/placement/get-survey-fields', params)
